export default __webpack_public_path__ + "static/media/carousel2.a0defbd9.jpg";